import React, { Component } from 'react'
import { connect } from '@cerebral/react'
import { state, signal } from 'cerebral/tags'
import canUpload from 'utils/canUpload'
import { css } from 'aphrodite'
import styles from './styles'
import filesUploading from 'modules/Media/computed/filesUploading'
import { t } from '@billes/translator-client'

function getStyle(fileCount) {
  switch (true) {
    case fileCount >= 1000:
      return {
        width: 22,
        fontSize: 8,
        marginLeft: 1,
        marginTop: 5,
        topPosition: 0,
        letterSpacing: -1
      }
    case fileCount >= 100:
      return {
        width: 19,
        fontSize: 9,
        marginLeft: 1,
        marginTop: 3,
        topPosition: 0,
        letterSpacing: -1
      }
    case fileCount >= 10:
      return {
        width: 18,
        fontSize: 9,
        marginLeft: 3,
        marginTop: 3,
        topPosition: 1,
        letterSpacing: 0
      }

    default:
      return {
        width: 15,
        fontSize: 10,
        marginLeft: 4,
        marginTop: 1,
        topPosition: 2,
        letterSpacing: 0
      }
  }
}

export default connect(
  {
    filesUploading: filesUploading,
    group: state`app.user.group`,
    showUploadPanel: signal`media.showUploadPanel`,
    medias: state`media.uploading.*`
  },
  class Upload extends Component {
    render() {
      const { filesUploading, group, showUploadPanel, medias } = this.props
      const filesUploadingCount = Object.keys(filesUploading).length
      const totalFileUploadingCount = Object.keys(medias).length
      if (!canUpload(group)) {
        return null
      }
      const fileCountSpecificStyle = getStyle(filesUploadingCount)
      const {
        topPosition,
        marginLeft,
        marginTop,
        width,
        fontSize,
        letterSpacing
      } = fileCountSpecificStyle
      return (
        <div
          style={{ position: 'relative', width: 45, height: '100%' }}
          title={t('bms.header.titles.showUpload', {
            count: filesUploadingCount
          })}
          onClick={e => {
            if (totalFileUploadingCount > 0) {
              showUploadPanel()
            }
          }}>
          {filesUploadingCount > 0 ? (
            <div
              className={css(styles.badge)}
              style={{
                marginTop: topPosition,
                background: 'rgb(0, 105, 180)',
                letterSpacing,
                width: width,
                height: width,
                fontSize
              }}>
              <span
                style={{
                  marginLeft,
                  display: 'block',
                  marginTop
                }}>
                {filesUploadingCount}
              </span>
            </div>
          ) : null}
          <svg
            className={css(
              styles.container,
              totalFileUploadingCount === 0 ? styles.noUploadingFiles : null
            )}
            style={{ marginTop: 4 }}
            viewBox={'-1 -8 38 38'}>
            <path
              d={
                'M14,13V17H10V13H7L12,8L17,13M19.35,10.03C18.67,6.59 15.64,4 12,4C9.11,4 6.6,5.64 5.35,8.03C2.34,8.36 0,10.9 0,14A6,6 0 0,0 6,20H19A5,5 0 0,0 24,15C24,12.36 21.95,10.22 19.35,10.03Z'
              }
            />
          </svg>
        </div>
      )
    }
  }
)



// WEBPACK FOOTER //
// ./src/components/NavigationBar/Upload/upload.js